import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from 'src/app/services/services.index';
import Swal from 'sweetalert2';
import { swalWarning } from '../shared/config/swalCommon';

@Injectable({
  providedIn: 'root'
})
export class RolesGuard implements CanActivate {

  url: string;

  constructor( private userService: UserService ) { }

  canActivate(routeSnapshot: ActivatedRouteSnapshot)
  {
    const roles = routeSnapshot.data['roles'] as Array<string>;
    const hasRole = roles.some(r=> this.userService.user.role.includes(r));

    if(hasRole)
      return true;
    else {
      let rolesText = roles.join(', ');

      if(roles.length > 1) {
        Swal.fire(swalWarning('¡Acceso denegado!',`Debe tener alguno de los siguientes roles para acceder: ${rolesText}`));
      }
      else if(roles.length === 1) {
        Swal.fire(swalWarning('¡Acceso denegado!',`Debe tener el siguiente rol para acceder: ${rolesText}`));
      }

      return false;
    }
  }
}
